import { cn } from "admin-ui/utils/cn"
import { IconProps } from "."

export default function SuccessIcon({
  className,
  transform,
  ...reset
}: Readonly<IconProps>) {
  return (
    <svg
      width="80"
      height="81"
      viewBox="0 0 80 81"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn("h-6 w-6", className)}
      transform={transform}
      {...reset}
    >
      <path
        d="M80 40.5012C80 43.5612 79.528 46.8566 79.056 49.6812C78.5841 51.5643 78.1121 53.212 77.4041 54.8597C73.3923 65.2167 65.1327 73.6905 54.7493 77.6921C53.8053 77.9275 53.3333 78.3982 52.3894 78.6336C48.3776 79.8105 44.3658 80.5167 40.118 80.5167C17.9351 80.5167 0 62.6274 0 40.5012C0 18.375 17.9351 0.485666 40.118 0.485666C62.0649 0.25028 80 18.375 80 40.5012Z"
        fill="url(#paint0_linear_669_27140)"
      />
      <path
        d="M79.0559 50.6234C78.5839 52.2711 78.1119 53.9188 77.404 55.5665C73.3922 65.6881 65.6046 73.4558 55.4571 77.4573L32.8022 54.8603L29.7344 51.8003L51.9173 32.028L59.2329 27.791L78.8199 47.328L79.0559 50.6234Z"
        fill="url(#paint1_linear_669_27140)"
      />
      <path
        d="M35.8702 56.0369C34.6903 56.0369 33.2743 55.5662 32.5664 54.6246L23.3628 45.4446C21.4749 43.5615 21.4749 40.7369 23.3628 38.8538C25.2507 36.9707 28.0826 36.9707 29.9705 38.8538L35.8702 44.7384L52.6254 28.0261C54.5133 26.143 57.3451 26.143 59.233 28.0261C61.1209 29.9092 61.1209 32.7338 59.233 34.6169L39.174 54.6246C38.2301 55.5662 37.0501 56.0369 35.8702 56.0369Z"
        fill="url(#paint2_linear_669_27140)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_669_27140"
          x1="40"
          y1="66.3175"
          x2="12.6361"
          y2="6.84765"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#24A762" />
          <stop offset="1" stopColor="#72CE57" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_669_27140"
          x1="43.8401"
          y1="39.1764"
          x2="61.875"
          y2="57.3748"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#297F1B" />
          <stop offset="0.496925" stopColor="#297F1B" stopOpacity="0.442001" />
          <stop offset="1" stopColor="#297F1B" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_669_27140"
          x1="51.4402"
          y1="46.8609"
          x2="34.8947"
          y2="30.3009"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0113208" stopColor="#CDFFC9" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
      </defs>
    </svg>
  )
}
